export default __webpack_public_path__ + "static/media/README.4e9dd095.md";